import { useCmsNew } from "@/lib/cms/cms-new-i18n";
import { ChevronRight, Home } from "lucide-react";

const SAMPLE_CRUMBS = [
  { name: "Accueil", current: false, home: true },
  { name: "Catalogue raisonné", current: false },
  { name: "Peintures", current: false },
  { name: "Sans titre", current: true },
];

/**
 * Aperçu canvas du bloc « Fil d'Ariane » — parité visuelle avec `Breadcrumbs`
 * côté front public (classes `cms-page-*`).
 */
export function BreadcrumbPreview({
  detailItemTitle = "auto",
  currentLabel,
}: {
  detailItemTitle?: "none" | "auto";
  /** Remplace le libellé d'exemple du dernier maillon (titre réel de la fiche). */
  currentLabel?: string;
}) {
  const cmsNew = useCmsNew();
  const crumbs =
    detailItemTitle === "auto"
      ? SAMPLE_CRUMBS.map((c) =>
          c.current && currentLabel ? { ...c, name: currentLabel } : c,
        )
      : SAMPLE_CRUMBS.slice(0, -1);

  return (
    <div className="w-full py-2">
      <nav className="flex" aria-label={cmsNew("cms.new.auto.label.breadcrumb_apercu", "Breadcrumb (aperçu)")}>
        <ol className="inline-flex items-center space-x-1 md:space-x-3">
          {crumbs.map((crumb, index) => (
            <li key={`${crumb.name}-${index}`} className="inline-flex items-center">
              {index > 0 ? (
                <ChevronRight
                  className="mx-1 h-3 w-3 cms-page-text-muted"
                  aria-hidden
                />
              ) : null}
              {crumb.home ? (
                <span className="inline-flex items-center text-sm font-medium cms-page-link">
                  <Home className="mr-2 h-3 w-3" aria-hidden />
                  {crumb.name}
                </span>
              ) : crumb.current ? (
                <span className="ml-1 text-sm font-medium cms-page-text-muted md:ml-2">
                  {crumb.name}
                </span>
              ) : (
                <span className="ml-1 text-sm font-medium cms-page-link md:ml-2">
                  {crumb.name}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
}
